import Base from "./base.service.js";
import Vue from "vue";
export default class Quote extends Base {
    constructor() {
        super("quote");
    }
    getListQuote() {
        return new Promise(resolve => {
            Vue.axios
                .get(this.path)
                .then(res => {
                    return resolve(res.data.data);
                })
                .catch(() => {});
        });
    }
    addFileQuote(params) {
        let headers = { 'Content-Type': 'multipart/form-data' };
        let formData = new FormData();
        formData.append('file', params);
        return new Promise(resolve => {
            Vue.axios
                .post(this.path, formData, {headers})
                .then(res => {
                    return resolve(res);
                })
                .catch(() => {});
        });
    }
    deleteQuote(id) {
        return new Promise(resolve => {
            Vue.axios
                .delete(this.path + id)
                .then(res => {
                    return resolve(res);
                })
                .catch(() => {});
        });
    }
}
